export const url = {
  new: "naujas"
};

export const pageTitles = {
  inviteTenantUser: "Pakviesti darbuotoją",
  updateTenantUser: "Atnaujinti darbuotoją",
  forms: "Stebėjimo anketos",
  users: "Naudotojai",
  updateProfile: "Atnaujinti profilį",
  tenantUsers: "Įmonės darbuotojai"
};

export const menuLabels = {};
export const buttonsTitles = {
  upload: "Įkelti duomenis",
  row: "Eil nr.",
  addNew: "+ Pridėti naują",
  add: "Pridėti",
  total: "Iš viso: ",
  download: "Parsisiųsti",
  clearAll: "Išvalyti viską",
  or: "arba",
  save: "Išsaugoti",
  importData: "Įkelti duomenis",
  filter: "Filtruoti",
  resetPassword: "Atstatyti slaptažodį",
  createPassword: "Nustatyti slaptažodį",
  eGates: "Prisijungti per el. valdžios vartus",
  edit: "Atnaujinti",
  view: "Peržiūrėti",
  removeTenantUser: "Pašalinti darbuotoją",
  deleteGroup: "Ištrinti grupę",
  sarasas: "Sąrašas",
  zemelapis: "Žemėlapis",
  padalintas: "Padalintas vaizdas",
  newTenant: "Nauja įmonė",
  cancel: "Atšaukti",
  delete: "Ištrinti",
  deleteRequest: "Ištrinti prašymą",
  deleteExcerpt: "Ištrinti išrašą"
};

export const descriptions = {
  stream: `Skirta įmonėms, kurios pateikia apskaičiavimo formą kartu su paraiška (prašymu) gauti, pakeisti ar 
  patikslinti TIPK leidimą, taršos leidimą, atliekų naudojimo ir šalinimo techninį reglamentą arba jei atsiranda 
  prievolė pateikti naują prievolių įvykdymo užtikrinimo dokumentą ir atliekų naudojimo ir šalinimo techninį reglamentas 
  buvo suderintas su AAA po Aplinkos ministro įsakymo Dėl Atliekas naudojančių ar šalinančių įmonių prievolių įvykdymo užtikrinimo įsigaliojimo.
 `,
  waste: `
  Skirta įmonėms, kurių atliekų naudojimo ar šalinimo techniniuose reglamentuose atliekos nėra suskirstytos į srautus, t. y. 
  atliekų naudojimo ir šalinimo techninis reglamentas buvo suderintas
   su AAA iki Aplinkos ministro įsakymo Dėl Atliekas naudojančių ar šalinančių įmonių prievolių įvykdymo užtikrinimo įsigaliojimo.
 `
};

export const formLabels = {
  mainTitle: "ĮMONĖS PRIEVOLIŲ ĮVYKDYMO UŽTIKRINIMO SUMOS APSKAIČIAVIMAS",
  formMainTitle: "ĮMONĖS PRIEVOLIŲ ĮVYKDYMO UŽTIKRINIMO SUMOS APSKAIČIAVIMAS",
  infoAboutCompany: "Duomenys apie įmonę",
  tableNotDangerous:
    "1 lentelė. Įmonės prievolių įvykdymo užtikrinimo suma nepavojingosioms atliekoms",
  tableDangerous:
    "2 lentelė. Įmonės prievolių įvykdymo užtikrinimo suma pavojingosioms atliekoms",
  tableDumpNotDangerous:
    "3 lentelė. Įmonės prievolių, susijusių su nepavojingų atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimu, įvykdymo užtikrinimo suma",
  tableDumpDangerous:
    "4 lentelė. Įmonės prievolių, susijusių su pavojingų atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimu, įvykdymo užtikrinimo suma",
  tableDumpInert:
    "5 lentelė. Įmonės prievolių įvykdymo užtikrinimo suma inertinių atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimo užtikrinimui",
  tablePhosphosGypsum:
    "6 lentelė. Įmonės prievolių, susijusių su nepavojingųjų atliekų sąvartynų, kuriuose šalinamos fosfogipso atliekos (toliau – fosfogipso atliekų sąvartynai) uždarymo ir priežiūros po uždarymo priemonių įgyvendinimui, įvykdymo užtikrinimo suma",
  totalSum: "7 lentelė. Bendra įmonės prievolių įvykdymo užtikrinimo suma",
  notDangerous:
    "Įmonės prievolių įvykdymo užtikrinimo suma nepavojingosioms atliekoms",
  dangerous:
    "Įmonės prievolių įvykdymo užtikrinimo suma pavojingosioms atliekoms",
  dumpNotDangerous:
    "Įmonės prievolių, susijusių su nepavojingų atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimu, įvykdymo užtikrinimo suma",
  dumpDangerous:
    "Įmonės prievolių, susijusių su pavojingų atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimu, įvykdymo užtikrinimo suma",
  dumpInert:
    "Įmonės prievolių įvykdymo užtikrinimo suma inertinių atliekų sąvartynų uždarymo ir priežiūros po uždarymo priemonių įgyvendinimo užtikrinimui",
  phosphosGypsum:
    "Įmonės prievolių, susijusių su nepavojingųjų atliekų sąvartynų, kuriuose šalinamos fosfogipso atliekos (toliau – fosfogipso atliekų sąvartynai) uždarymo ir priežiūros po uždarymo priemonių įgyvendinimui, įvykdymo užtikrinimo suma"
};

export const inputLabels = {
  noData: "Nėra duomenų",
  chooseOption: "Pasirinkite",
  comment: "Komentaras",
  or: "arba",
  uploadPhotos: "Įkelti nuotraukas",
  receiveDate: "Nurodykite, kokios dienos situaciją norite gauti",
  pressToWant: "Paspauskite norėdami",
  uploadOrDragFilesHere: "įkelti arba įtempkite failus čia",
  fileTypesAndMaxSize: "PDF, DOCX, DOC, PNG, JPEG, JPG (maks. 20MB)",
  profiles: "PASKYROS",
  description: "Duomenų tikrinimo tikslas",
  repliesWIllBeSentToThisEmail:
    "Šiuo el. pašto adresu bus siunčiama informacija apie prašymo būseną",

  firstName: "Vardas",
  lastName: "Pavardė",
  phone: "Telefonas",
  email: "El. pašto adresas",
  noOptions: "Nėra pasirinkimų",
  year: "Metai",
  yearCoeffCient: "Prievolių įvykdymo užtikrinimo suma eurais",
  notDangerousStreamCode: "Nepavojingųjų atliekų srauto kodas",
  notDangerousWasteCode: "Nepavojingųjų atliekų kodas",
  dangerousStreamCode: "Pavojingųjų atliekų srauto kodas",
  dangerousWasteCode: "Pavojingųjų atliekų kodas",
  coefficient: "Koeficientas",
  code: "Atliekų tvarkymo veiklos (naudojimo ar šalinimo) kodas",
  sum: "Prievolių įvykdymo užtikrinimo suma eurais",
  totalSum: "Bendra prievolių įvykdymo užtikrinimo suma eurais",
  maxTotalSum:
    "Didžiausia įsipareigojimų, užtikrinant prievolių įvykdymą maksimaliąja hipoteka, apsaugos suma eurais ",
  quantity: "Atliekų kiekis, tonomis",
  expectedToBeRemovedDumpNotDangerousQuantity:
    "Numatomų pašalinti ir pašalintų nepavojingųjų atliekų kiekių neuždarytuose sąvartynuose ar atskirose neuždarytose sąvartyno dalyse suma tonomis",
  removedDumpNotDangerousQuantity:
    "Pašalintų nepavojingųjų atliekų kiekių uždarytuose sąvartynuose ar atskirose uždarytose sąvartyno dalyse suma tonomis",
  expectedToBeRemovedDumpDangerousQuantity:
    "Numatomų pašalinti ir pašalintų pavojingųjų atliekų kiekių neuždarytuose sąvartynuose ar atskirose neuždarytose sąvartyno dalyse suma tonomis",
  removedDumpDangerousQuantity:
    "Pašalintų pavojingųjų atliekų kiekių uždarytuose sąvartynuose ar atskirose uždarytose sąvartyno dalyse suma tonomis",
  expectedToBeRemovedDumpPhosphogypsumQuantity:
    "Numatomų pašalinti ir pašalintų fosfogipso atliekų kiekių neuždarytuose sąvartynuose ar atskirose neuždarytose sąvartyno dalyse suma tonomis",
  removedDumpPhosphogypsumQuantity:
    "Pašalintų fosfogipso atliekų kiekių uždarytuose sąvartynuose ar atskirose uždarytose sąvartyno dalyse  suma tonomis",
  dumpInertQuantity: "Inertinių atliekų kiekio suma tonomis",
  setAside: "Atidėjimų suma eurais",
  fullName: "Įmonės vadovo parašas, vardas, pavardė",
  company: "Įmonės veiklavietės adresas",
  companyName: "Įmonės pavadinimas",
  companyCode: "Įmonės kodas",
  pollutionNumber: "Taršos arba TIPK leidimo Nr.",
  ns1: "Dydis pagal Tvarkos aprašo* 1 priedo 3 punktą",
  ns2: "Dydis pagal Tvarkos aprašo* 1 priedo 4 punktą",
  nk1: "Dydis pagal Tvarkos aprašo* 1 priedo 5 punktą ",
  nk2: "Dydis pagal Tvarkos aprašo* 1 priedo 6 punktą",
  n1: "Dydis pagal Tvarkos aprašo* 1 priedo 7 punktą",
  nf1: "Dydis pagal Tvarkos aprašo* 1 priedo 8 punktą",
  nf2: "Dydis pagal Tvarkos aprašo* 1 priedo 9 punktą"
};
export const bottomLabels = {
  yearCoeffiCient:
    "skiltis užsipildo automatiškai, nurodžius formos pateikimo metus",
  totalSum: "skiltis užsipildo automatiškai, užpildžius visus laukelius",
  coeffiCient:
    "skiltis užsipildo automatiškai, užpildžius veiklos kodą ir srauto kodą",
  streamCode: "skiltis užsipildo automatiškai, užpildžius atliekų kodą",
  code: "(nurodoma R (naudojimas) arba D (šalinimas) arba S (paruošimas naudoti ir šalinti)",
  disabled: "(ši skiltis nepildoma)"
};

export const validationTexts = {
  requireText: "Privalomas laukelis",
  atLeastOneColumn: "Turi būti pasirinktas bent vienas stulpelis",
  error: "Įvyko klaida"
};

export const deleteTitles = {
  tenantUser: "Pašalinti darbuotoją"
};

export const deleteDescriptionFirstPart = {
  tenantUser: "Ar esate tikri, kad norite pašalinti ",
  request: "Ar esate tikri, kad norite ištrinti "
};

export const deleteDescriptionSecondPart = {
  tenantUser: " darbuotoją?"
};

export const notDangerousLabels = {
  streamCode: inputLabels.notDangerousStreamCode,
  wasteCode: inputLabels.notDangerousWasteCode,
  yearCoeffCient:
    "Nustatytas dydis vienai tonai numatomų naudoti ar šalinti nepavojingųjų atliekų",
  quantity: inputLabels.quantity,
  code: inputLabels.code,
  coefficient: inputLabels.coefficient,
  totalSum:
    "Prievolių, susijusių su visomis nepavojingosiomis atliekomis, įvykdymo užtikrinimo suma eurais"
};

export const dangerousLabels = {
  streamCode: inputLabels.dangerousStreamCode,
  wasteCode: inputLabels.dangerousWasteCode,
  yearCoeffCient:
    "Nustatytas dydis vienai tonai numatomų naudoti ar šalinti pavojingųjų atliekų",
  quantity: inputLabels.quantity,
  code: inputLabels.code,
  coefficient: inputLabels.coefficient,
  totalSum:
    "Prievolių, susijusių su visomis pavojingosiomis atliekomis, įvykdymo užtikrinimo suma eurais"
};
